import {createSlice} from "@reduxjs/toolkit";

const UserSlice = createSlice({
  name:"user",
  initialState:{
    user: JSON.parse(localStorage.getItem("user_data")) || null
  },
  reducers:{
    setUser:(state, action)=>{
      state.user = action.payload;
      localStorage.setItem("user_data", JSON.stringify(action.payload));
    },
    clearUser:(state)=>{
      state.user = null;
      localStorage.removeItem("user_data");
      localStorage.removeItem("auth_token");
    }
  }
})

export const {setUser, clearUser} = UserSlice.actions;
export default UserSlice.reducer;
